import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AdvertiserService } from '../../services/advertiser.service';
import { Observable, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import {
  DeleteAdvertiserActionError,
  DeleteAdvertiserActionSuccess,
  GetAllAdvertisersActionError,
  GetAllAdvertisersActionSuccess,
  NewAdvertiserActionSuccess,
  NewAdvertiserActionError,
  AdvertiserActions,
  AdvertiserActionsTypesNgrx,
  SearchAdvertisersActionError,
  SearchAdvertisersActionSuccess,
  SaveAdvertiserActionSuccess,
  SaveAdvertiserActionError,
  EditAdvertiserActionSuccess,
  EditAdvertiserActionError,
  UpdateAdvertiserActionError,
  UpdateAdvertiserActionSuccess,
  GetAdvertiserByNameActionError,
  GetAdvertiserByNameActionSuccess,
} from './advertisers.action';


@Injectable()
export class AdvertisersEffects {
  constructor(
    private effectAction: Actions,
    private advertiserService: AdvertiserService
  ) { }



    /*Get ADVERTISER BY NAME ACTIONS*/
    getAdvertiserByNamesSuccessEffect: Observable<AdvertiserActions> = createEffect(() =>
    this.effectAction.pipe(
      ofType(AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME),
      mergeMap((action: AdvertiserActions) => {
        return this.advertiserService
          .getAdvertiserByName(action.payload)
          .pipe(map((advertiser) => new  GetAdvertiserByNameActionSuccess(advertiser)),
            catchError((err) => of(new GetAdvertiserByNameActionError(err)))
          );
      })
    )
  );

}
